import ModelBase from "./shared/model-base.js";

interface ModelAttributes {
  id: string | number;
  name?: string;
  description?: string;
  started_at?: string;
  ended_at?: string;
  location?: string;
  link_url?: string;
  image_url?: string;
  is_published?: boolean;
  published_state?: string;
  published_at?: string;
  country_id: string | number;
  creator_member_id?: string | number;
  created_at?: string;
  updated_at?: string;
}

const OPTIONS = {
  i18nModelName: "event",
  columns: [
    "id",
    "name",
    "description",
    "started_at",
    "ended_at",
    "location",
    "link_url",
    "image_url",
    "is_published",
    "published_state",
    "published_at",
    "country_id",
    "creator_member_id",
    "created_at",
  ],
  editColumns: {},
};

export default class Event extends ModelBase {
  declare id: string | number;
  declare name: string;
  declare description: string;
  declare started_at: string;
  declare ended_at: string;
  declare location: string;
  declare link_url: string;
  declare image_url: string;
  declare is_published: boolean;
  declare published_state: string;
  declare published_at: string;
  declare country_id: string | number;
  declare creator_member_id: string | number;
  declare created_at: string;

  constructor(attributes: Partial<ModelAttributes> = {}) {
    super(OPTIONS, attributes);
  }
}
